console.log("testimonials.js loaded");

const html = document.documentElement;
const body = document.body;

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

var testimonials_gallery_swipers = [];

function initialiseSwipers()
{
    testimonials_gallery_swipers.forEach(testimonials_gallery_swiper =>
    {
        if (testimonials_gallery_swiper instanceof Swiper)
        {
            testimonials_gallery_swiper.destroy();
        }
    });
    
    document.querySelectorAll('section.testimonials.gallery_mode .testimonials_container').forEach((gallery, index) => {
        const parent_section = gallery.closest("section");
        let loop = true;
        const number_of_slides = gallery.querySelectorAll(".swiper-slide").length;
        let autoplay = false;

        if (parent_section.classList.contains("autoplay"))
        {
            autoplay = { delay: 5000, }
        }
        
        let desktopSlidesPerView = 1;
        let i;
        for (i=2;i<=10;i++)
        {
            if (parent_section.classList.contains("slides_per_view_"+i))
            {
                desktopSlidesPerView = i;
                break;
            }
        }
        
        let mobileSlidesPerView = 1;

        for (i=2;i<=10;i++)
        {
            if (parent_section.classList.contains("slides_per_view_mobile_"+i))
            {
                mobileSlidesPerView = i;
                break;
            }
        }
        if (parent_section.classList.contains("hide_navigation_arrows"))
        {
            gallery.querySelector(".swiper-button-prev").remove();
            gallery.querySelector(".swiper-button-next").remove();
        }
        if (parent_section.classList.contains("hide_pagination_dots"))
        {
            gallery.querySelector(".swiper-pagination").remove();
        }
        let swiper_options = {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            loop: loop,
            autoplay: autoplay,
            zoom: true,
            slidesPerView: mobileSlidesPerView,
            slidesPerGroup: mobileSlidesPerView,
            watchOverflow: true,
            centerInsufficientSlides: true,
        
            navigation: {
                    nextEl: parent_section.querySelector(".swiper-button-next"),
                    prevEl:  parent_section.querySelector(".swiper-button-prev"),
                },
            pagination: {
                    el: gallery.querySelector(".swiper-pagination"),
                    clickable: true,
            },

            breakpoints: {
                0: {
                    slidesPerView: mobileSlidesPerView,
                    slidesPerGroup: mobileSlidesPerView,
                },
                768: {
                    slidesPerView: desktopSlidesPerView,
                    slidesPerGroup: desktopSlidesPerView,
                }
            }
        };
        console.log(mobileSlidesPerView, desktopSlidesPerView);
        let gallery_swiper = new Swiper(gallery.querySelector(".swiper"), swiper_options);
    });

}

document.addEventListener("DOMContentLoaded", () => {
    initialiseSwipers();
});